import { render, staticRenderFns } from "./TruckScheduleTruckTypeLinkedTruckTypeForm.vue?vue&type=template&id=06fe7354&"
import script from "./TruckScheduleTruckTypeLinkedTruckTypeForm.vue?vue&type=script&lang=js&"
export * from "./TruckScheduleTruckTypeLinkedTruckTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VForm,VIcon,VRow})
